import { useState, useEffect, useCallback } from 'react';
import { ArrowClockwise } from '@phosphor-icons/react';

const CURRENT_VERSION = '1.3.1';
const CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

export const UpdateBanner = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  const checkVersion = useCallback(async () => {
    try {
      const resp = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
      if (!resp.ok) return;
      const { version } = await resp.json();
      if (version && version !== CURRENT_VERSION) {
        setUpdateAvailable(true);
      }
    } catch {}
  }, []);

  useEffect(() => {
    // First check after 30s (let the app load)
    const initial = setTimeout(checkVersion, 30000);
    const interval = setInterval(checkVersion, CHECK_INTERVAL);
    return () => { clearTimeout(initial); clearInterval(interval); };
  }, [checkVersion]);

  if (!updateAvailable) return null;

  return (
    <div
      className="bg-emerald-600 text-white py-2.5 px-4 relative z-50"
      role="alert"
      data-testid="update-banner"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-sm font-medium">
        <ArrowClockwise size={18} weight="bold" className="animate-spin" />
        <span>A new version of TurfPulse is available.</span>
        <button
          onClick={() => window.location.reload()}
          className="underline underline-offset-2 font-bold hover:opacity-80 transition-opacity"
          data-testid="update-refresh-btn"
        >
          Refresh now
        </button>
      </div>
    </div>
  );
};
